import { useEffect, useState, type ReactNode } from "react";
import { ThemeContext, type ITheme, type TBreakpoint } from "../contexts/ThemeContext";

const breakpoints = {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
};

export const ThemeProvider: React.FC<{ theme: ITheme, children: ReactNode }> = ({ theme, children }) => {
    const [breakpoint, setBreakpoint] = useState<TBreakpoint>(() => getBreakpoint(window.innerWidth));

    function getBreakpoint(width: number): TBreakpoint {
        if (width < breakpoints.sm) return { xs: true, sm: false, md: false, lg: false, xl: false };
        if (width < breakpoints.md) return { xs: false, sm: true, md: false, lg: false, xl: false };
        if (width < breakpoints.lg) return { xs: false, sm: false, md: true, lg: false, xl: false };
        if (width < breakpoints.xl) return { xs: false, sm: false, md: false, lg: true, xl: false };
        return { xs: false, sm: false, md: false, lg: false, xl: true };
    }

    useEffect(() => {
        const onResize = () => {
            const newBreakpoint = getBreakpoint(window.innerWidth);
            setBreakpoint(prev => (prev !== newBreakpoint ? newBreakpoint : prev));
        };

        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <ThemeContext.Provider value={{ theme, breakpoint }}>
            {children}
        </ThemeContext.Provider>
    );
};
